var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbstractOpaco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1137,
    height: 527,
    viewBox: "0 0 1137 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 518.264C-457.978 502.683 -285.12 497.372 -114.639 509.669C-45.0068 514.69 24.8137 517.169 94.4695 511.89C170.43 506.128 242.744 483.144 317.692 469.109C450.982 444.129 586.129 502.812 718.854 512.598C858.66 522.931 995.948 496.084 1136.11 520.549",
    stroke: "url(#paint0_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 482.403C-451.391 455.653 -268.112 450.76 -90.8558 474.774C-19.7886 484.399 51.8668 489.485 123.052 479.281C207.057 467.274 279.959 423.044 360.789 396.036C495.796 350.937 629.085 460.449 761.621 478.251C819.797 486.073 877.385 468.98 935.42 463.862C1004.04 457.778 1069.51 467.467 1136.11 490.741",
    stroke: "url(#paint1_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 443.517C-445.957 407.367 -258.561 411.81 -76.1531 445.32C-4.38018 458.486 67.4399 465.729 139.377 450.47C176.805 442.519 213.315 429.16 249.025 411.938C297.579 388.536 342.346 345.529 390.5 324.026C525.648 263.669 653.903 417.668 782.064 445.191C840.875 457.81 894.534 431.639 952.475 422.593C1017 412.518 1075.77 429.772 1136.13 460.965",
    stroke: "url(#paint2_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 402.185C-449.791 359.404 -267.501 372.795 -89.7031 416.092C-12.5431 434.891 64.7346 447.284 142.365 425.717C240.932 398.322 313.623 317.234 403.862 265.408C550.208 181.358 666.747 385.253 803.26 416.253C857.154 428.485 901.592 397.26 953.181 383.644C1019.4 366.164 1076.61 391.884 1136.11 431.189",
    stroke: "url(#paint3_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 359.081C-449.65 308.929 -274.487 338.608 -98.5483 392.914C-21.153 416.799 56.454 429.868 134.532 403.44C175.064 389.727 213.362 367.354 250.342 341.087C305.695 301.782 354.673 236.114 410.214 200.994C559.5 106.579 666.018 344.66 798.813 384.19C859.248 402.185 899.451 362.655 955.18 343.244C1021.42 320.195 1079.18 357.375 1136.11 401.38",
    stroke: "url(#paint4_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 314.884C-453.179 258.004 -292.625 305.485 -123.014 368.675C-44.254 398 34.4586 415.737 114.653 385.317C157.091 369.222 196.589 342.697 234.51 312.47C293.933 265.118 345.192 189.631 405.015 146.689C562.134 33.9257 655.314 310.41 791.097 354.446C854.919 375.145 892.299 327.696 949.134 303.199C1017.92 273.552 1079.06 322.803 1136.08 371.572",
    stroke: "url(#paint5_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 270.204C-461.059 207.175 -319.089 269.431 -160.676 340.701C-82.1047 376.046 -3.7449 402.507 78.1435 373.535C202.729 329.466 283.935 195.361 388.642 105.002C558.676 -41.6902 634.448 284.979 782.793 326.569C847.015 344.596 883.337 288.552 940.101 261.48C1011.99 227.197 1078.35 288.938 1136.11 341.699",
    stroke: "url(#paint6_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 225.749C-466.023 154.061 -341.485 234.633 -192.528 314.498C-112.098 357.601 -30.7509 392.56 54.9484 356.925C182.004 304.101 264.81 160.209 369.846 60.1287C548.42 -109.998 607.043 253.529 760.422 296.278C825.702 314.466 865.999 252.274 921.893 221.918C1000.84 179.04 1073.32 252.016 1136.11 311.987",
    stroke: "url(#paint7_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 182.099C-555.557 144.21 -484.631 135.487 -409.47 166.068C-340.073 194.299 -280.486 251.308 -214.994 291.643C-137.646 339.285 -58.1804 381.068 26.4604 343.115C160.902 282.823 241.826 119.102 351.544 10.491C529.2 -165.398 580.883 209.525 726.735 260.096C800.578 285.688 843.369 211.488 906.155 177.56C991.008 131.688 1070.29 217.315 1136.11 282.179",
    stroke: "url(#paint8_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 139.961C-562.826 99.4336 -497.663 86.8149 -428.596 118.49C-360.563 149.683 -305.304 215.352 -242.635 260.805C-169.733 313.694 -94.7138 366.776 -10.8258 332.911C129.827 276.192 218.114 92.3195 327.267 -26.6566C513.392 -229.553 544.279 178.461 696.764 225.427C775.007 249.538 823.726 163.493 890.911 129.95C981.292 84.8513 1067.98 183.386 1136.08 252.338",
    stroke: "url(#paint9_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 99.9481C-477.079 -11.1091 -386.299 120.26 -263.196 226.425C-193.281 286.717 -118.003 356.474 -32.3271 317.653C106.42 254.785 197.695 65.7619 302.872 -59.9421C370.764 -141.062 435.761 -159.894 493.914 -57.2703C544.35 31.7043 576.743 159.855 666.489 185.639C744.637 208.076 799.825 120.003 866.87 84.1105C965.531 31.2536 1063.2 146.818 1136.11 222.562",
    stroke: "url(#paint10_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 62.7364C-481.831 -63.1607 -390.604 67.565 -275.146 186.219C-213.559 249.506 -143.833 337.161 -60.6269 307.449C-9.97891 289.358 34.9292 237.949 73.6033 192.561C147.94 105.357 209.645 2.47573 280.218 -89.6535C347.874 -177.984 414.566 -212.75 472.577 -96.2204C515.815 -9.3704 548.984 124.8 635.907 143.76C718.548 161.787 779.029 64.7643 851.508 31.2218C956.05 -17.1927 1061.44 112.921 1136.11 192.689",
    stroke: "url(#paint11_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 29.0003C-571.153 -27.1722 -508.179 -62.4208 -438.641 -28.2023C-376.724 2.2821 -328.593 73.1013 -281.004 132.106C-227.368 198.612 -159.618 316.687 -77.2823 293.477C-30.9392 280.408 9.8286 231.865 44.4565 190.532C120.887 99.2721 187.885 -6.44148 256.6 -108.131C320.915 -203.351 392.194 -271.852 452.181 -139.324C492.573 -50.124 523.931 90.9669 615.535 95.9243C696.835 100.334 757.928 11.4886 831.206 -21.2814C943.606 -71.5308 1057.63 76.1593 1136.13 162.913",
    stroke: "url(#paint12_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -1.9673C-569.648 -64.4169 -504.391 -105.878 -430.407 -69.8892C-367.973 -39.5336 -316.267 29.676 -270.112 91.9002C-222.122 156.635 -157.712 283.788 -79.1406 262.091C-35.1735 249.956 3.50059 201.316 35.9172 161.85C110.043 71.5559 176.24 -31.3894 243.214 -131.277C304.542 -222.73 376.574 -306.103 437.408 -174.187C477.211 -87.8838 507.44 49.8594 597.327 51.5655C677.921 53.0785 745.131 -26.9793 820.385 -54.4056C937.513 -97.1224 1051.98 42.9063 1136.11 132.364",
    stroke: "url(#paint13_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -36.4753C-563.602 -106.039 -494.652 -143.444 -415.657 -95.1586C-350.33 -55.2101 -293.119 20.3732 -242.565 87.2972C-197.21 147.365 -141.01 248.733 -69.4957 217.154C-25.858 197.872 12.0869 146.367 44.6447 104.97C109.901 22.0148 170.547 -67.8288 232.111 -155.838C290.78 -239.758 361.965 -321.393 425.034 -204.381C469.895 -121.136 498.454 12.0036 588.011 18.0876C667.782 23.4956 744.919 -48.5146 821.82 -67.8289C938.125 -97.0578 1046.29 12.6475 1136.13 97.1797",
    stroke: "url(#paint14_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -74.8141C-558.733 -147.371 -487.924 -179.272 -406.741 -121.973C-344.543 -78.0976 -287.143 -7.43935 -235.978 57.0382C-188.294 117.138 -129.742 220.695 -57.6864 174.856C-20.0709 150.938 10.8872 105.388 40.4339 66.8563C102.585 -14.2638 161.373 -100.277 222.066 -183.393C284.852 -269.374 355.99 -336.04 421.129 -221.732C465.967 -143.026 498.266 -19.1245 583.283 -13.974C661.501 -9.20982 739.202 -60.4893 815.539 -77.5503C933.373 -103.882 1037.99 -21.6675 1136.13 57.5533",
    stroke: "url(#paint15_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -116.276C-548.076 -195.4 -471.622 -213.298 -386.275 -139.678C-324.947 -86.7891 -268.253 -15.133 -213.371 49.4733C-167.545 103.425 -116.003 188.118 -51.8759 139.059C-17.5303 112.792 11.0519 65.9549 38.4107 28.0667C96.6571 -52.6349 153.374 -135.3 213.315 -213.684C275.419 -294.901 346.51 -353.52 412.613 -250.896C461.967 -174.283 496.148 -52.0877 580.954 -41.0141C655.691 -31.2604 737.132 -71.2411 810.646 -86.8213C928.127 -111.705 1031.49 -54.8883 1136.08 14.4823",
    stroke: "url(#paint16_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -160.087C-541.395 -240.016 -461.553 -248.579 -374.537 -164.948C-308.88 -101.854 -249.881 -22.1185 -187.447 47.0267C-144.515 94.5399 -97.0192 159.693 -43.36 105.098C-7.88525 69.0128 21.0733 14.6431 50.5258 -29.651C100.327 -104.494 151.375 -178.339 206.163 -246.39C273.302 -329.795 346.11 -369.197 413.719 -268.666C463.214 -195.078 501.136 -80.2224 582.459 -67.7647C659.431 -55.983 742.661 -83.6345 818.903 -97.9593C931.021 -119.012 1030.81 -84.729 1136.11 -31.3893",
    stroke: "url(#paint17_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -205.572C-529.233 -290.266 -445.086 -281.252 -354.211 -181.977C-285.261 -106.651 -226.498 -18.9961 -154.631 52.0805C-105.323 100.817 -69.7779 128.34 -24.7758 60.4179C51.702 -55.0173 113.642 -186.58 203.246 -286.113C269.02 -359.153 341.381 -386.386 406.92 -301.371C462.297 -229.554 499.559 -119.302 579.495 -93.4205C653.291 -69.5673 745.907 -93.0986 820.103 -106.941C929.609 -127.382 1028.43 -115.374 1136.13 -79.0636",
    stroke: "url(#paint18_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -251.958C-517.377 -340.45 -427.114 -311.704 -333.651 -198.426C-266.701 -117.273 -211.018 -23.3092 -135.035 43.3574C-79.2583 92.3191 -49.8998 100.978 -11.7432 23.0129C48.7145 -100.502 109.572 -226.753 197.647 -317.852C268.856 -391.536 341.005 -408.082 410.59 -323.132C468.531 -252.377 509.769 -138.551 591.704 -113.507C664.371 -91.2956 749.177 -101.854 822.432 -115.503C928.786 -135.332 1028.69 -144.281 1136.13 -127.896",
    stroke: "url(#paint19_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -298.506C-507.402 -389.766 -412.881 -344.796 -317.113 -219.929C-249.34 -131.566 -193.469 -23.6312 -110.028 39.0115C-48.0885 85.5268 -26.3519 61.3518 3.1947 -18.3841C50.1964 -145.183 109.643 -273.333 196.706 -355.934C270.408 -425.884 344.957 -428.041 414.189 -347.661C474.577 -277.518 518.567 -166.654 599.468 -135.558C772.984 -68.8589 961.814 -168.553 1136.13 -176.826",
    stroke: "url(#paint20_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -344.506C-568.119 -388.317 -511.613 -414.327 -444.357 -382.426C-388.722 -356.03 -343.155 -300.63 -302.34 -244.2C-235.013 -151.041 -177.449 -25.6912 -87.7506 29.6765C-20.4709 71.2023 -4.54479 15.2551 18.1563 -62.8068C55.1601 -190.152 111.031 -320.621 198.33 -395.174C388.595 -557.704 457.263 -228.845 608.642 -157.543C785.428 -74.2666 963.249 -179.336 1136.13 -225.144",
    stroke: "url(#paint21_linear_421_342)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-628.224 -389.219C-565.531 -434.607 -507.755 -459.909 -439.276 -425.433C-381.829 -396.526 -335.392 -337.456 -293.777 -277.614C-228.332 -183.521 -160.653 -20.6372 -63.0264 16.8325C5.31194 43.0678 16.0861 -44.426 33.4001 -114.859C63.6995 -238.148 115.924 -374.089 203.293 -439.307C384.666 -574.7 476.012 -270.275 612.947 -184.229C792.603 -71.3373 966.566 -187.094 1136.11 -272.013",
    stroke: "url(#paint22_linear_421_342)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_342",
    x1: 253.941,
    y1: 462.97,
    x2: 253.941,
    y2: 520.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_421_342",
    x1: 253.941,
    y1: 385.229,
    x2: 253.941,
    y2: 490.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_421_342",
    x1: 253.953,
    y1: 310.12,
    x2: 253.953,
    y2: 460.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_421_342",
    x1: 253.941,
    y1: 245.242,
    x2: 253.941,
    y2: 437.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_421_342",
    x1: 253.941,
    y1: 179.027,
    x2: 253.941,
    y2: 418.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_421_342",
    x1: 253.929,
    y1: 119.866,
    x2: 253.929,
    y2: 401.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_421_342",
    x1: 253.941,
    y1: 67.374,
    x2: 253.941,
    y2: 385.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_421_342",
    x1: 253.941,
    y1: 15.084,
    x2: 253.941,
    y2: 371.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_421_342",
    x1: 253.941,
    y1: -36.1221,
    x2: 253.941,
    y2: 357.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_421_342",
    x1: 253.929,
    y1: -82.873,
    x2: 253.929,
    y2: 343.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_421_342",
    x1: 253.941,
    y1: -127.643,
    x2: 253.941,
    y2: 328.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_421_342",
    x1: 253.941,
    y1: -170.529,
    x2: 253.941,
    y2: 313.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_421_342",
    x1: 253.953,
    y1: -213.021,
    x2: 253.953,
    y2: 296.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_421_342",
    x1: 253.941,
    y1: -242.695,
    x2: 253.941,
    y2: 264.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_421_342",
    x1: 253.953,
    y1: -262.684,
    x2: 253.953,
    y2: 223.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_421_342",
    x1: 253.953,
    y1: -282.516,
    x2: 253.953,
    y2: 186.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_421_342",
    x1: 253.929,
    y1: -305.645,
    x2: 253.929,
    y2: 153.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_421_342",
    x1: 253.941,
    y1: -328.39,
    x2: 253.941,
    y2: 125.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_421_342",
    x1: 253.953,
    y1: -354.064,
    x2: 253.953,
    y2: 100.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_421_342",
    x1: 253.953,
    y1: -380.26,
    x2: 253.953,
    y2: 80.8842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_421_342",
    x1: 253.953,
    y1: -408.194,
    x2: 253.953,
    y2: 62.5368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_421_342",
    x1: 253.953,
    y1: -439.753,
    x2: 253.953,
    y2: 43.7815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_421_342",
    x1: 253.941,
    y1: -473.514,
    x2: 253.941,
    y2: 21.5953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293543"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractOpaco);
export default __webpack_public_path__ + "static/media/AbstractOpaco.f069217a713c1d0ac07799531072c1ca.svg";
export { ForwardRef as ReactComponent };